import { SET_AVAILABILITY_STATUS, SUBMITTING } from './constants';

const initialState = {
  isAvailable: false,
  submitting: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AVAILABILITY_STATUS:
      return {
        ...state,
        isAvailable: action.payload,
      };
    case SUBMITTING:
      return {
        ...state,
        submitting: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;